import { nestClient, type NestClient, type NestRequestOptions } from "../nest/client"
import type { AppOperationMap, AppOperationName } from "./app-generated"

export interface AgentIdentity {
    taskId: string
    workspaceId: string
    sessionId: string
}

export interface AgentAuthorizeResult {
    authorized: boolean
    /** Older Nests return only authorized. */
    actor?: AgentIdentity
}

export interface AgentAccess extends AgentIdentity {
    modules: string[]
    role?: "chief-of-staff"
}

export interface AppModuleDescription {
    id: string
    description: string
    execution: "nest" | "client"
    operations: Array<{ name: string; module: string; description: string; effect: string; inputSchema: unknown }>
    clientTools?: Record<string, string>
}

export interface AgentAccessResult {
    access: AgentAccess
    available: AppModuleDescription[]
    version: number
}

export function requestAppOperation<M extends AppOperationName>(
    operation: M,
    params: AppOperationMap[M]["params"],
    options?: NestRequestOptions,
    client: NestClient = nestClient
): Promise<AppOperationMap[M]["result"]> {
    return client.requestModuleMethod<AppOperationMap[M]["result"]>(`wildlark.app.${operation}`, params, options)
}

export function readAgentAccess(sessionId: string, options?: NestRequestOptions, client: NestClient = nestClient): Promise<AgentAccessResult> {
    return client.requestModuleMethod<AgentAccessResult>("wildlark.agent.access.read", { sessionId }, options)
}

export function setAgentAccess(
    access: AgentAccess & { expectedVersion?: number },
    options?: NestRequestOptions,
    client: NestClient = nestClient
): Promise<AgentAccessResult> {
    return client.requestModuleMethod<AgentAccessResult>("wildlark.agent.access.set", access, options)
}
